<template>
  <v-snackbar
    v-model="snackbar"
    :color="color"
    :timeout="timeout"
    @input="handleSnackbarChange"
  >
    {{ text }}

    <template slot="action" slot-scope="{ attrs }">
      <v-btn
        v-bind="attrs"
        icon
        class="solvit-snackbar-action-btn"
        @click="closeAlert"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'AdminAlertBar',
  data:() => ({
    snackbar: false,
    text: '',
    color: '',
    timeout: 3000
  }),
  computed: {
    alertData() {
      return this.$store.getters['defectAlert/alertData'];
    }
  },
  watch: {
    alertData: {
      handler(newData) {
        console.log('[ADMIN ALERT BAR] alertData changed:', newData);

        if (newData && newData.show) {
          this.snackbar = true;
          this.color = newData.status || 'info';
          this.text = newData.message || '';
          this.timeout = newData.status === 'error' ? 0 : 3000;
        } else {
          this.snackbar = false;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    closeAlert() {
      this.$store.dispatch('defectAlert/hideAlert');
    },
    handleSnackbarChange(value) {
      if (!value) {
        this.closeAlert();
      }
    }
  }
};
</script>

<style scoped>

</style>
